import { formatRelative } from 'date-fns';
import dayjs from 'dayjs';
import React from 'react';
import styled from 'styled-components';
import { Box, Column, Row } from '../../Flex';

const Container = styled(Column)`
  background: #f6f9fc 0% 0% no-repeat padding-box;
  border: 1px solid #e2e3e3;
  border-radius: 4px;
  opacity: 1;
`;

const Content = styled(Column)`
  padding: 1rem;
  padding-bottom: 0.1rem;
  padding-right: 0.3rem;
`;

const Title = styled.p`
  margin: 0;
  text-align: left;
  font: normal normal 600 0.8rem Poppins;
  letter-spacing: 0px;
  color: #717884;
  opacity: 1;
`;

const Description = styled.p`
  margin: 0;
  text-align: left;
  font: normal normal normal 0.8rem Poppins;
  letter-spacing: 0px;
  color: #717884;
  opacity: 1;
`;

const TimestampRow = styled(Row)`
  justify-content: flex-end;
  margin-top: 0.5rem;
`;

const Timestamp = styled.p`
  margin: 0;
  color: #b0b0b0;
  font-size: 10px;
`;

type TimelineCardProps = {
  message: string;
  type: string;
  createdAt: string;
};

const TIMELINE_TYPE_MAP = {
  NEW_SALE: 'Sale',
  NEW_PURCHASE: 'Purchase',
  PAYOUT: 'Payout',
};

const TimelineCard = (props: TimelineCardProps) => {
  return (
    <Container>
      <Column className="px-4 pt-2 pb-1">
        <Title>
          {TIMELINE_TYPE_MAP[props.type]
            ? TIMELINE_TYPE_MAP[props.type]
            : props.type}
        </Title>
        <Box height={5} />
        <Description>{props.message}</Description>
        <TimestampRow>
          <Timestamp>
            {formatRelative(
              dayjs(props.createdAt).tz('GMT', true).toDate(),
              new Date(),
            )}
          </Timestamp>
        </TimestampRow>
      </Column>
    </Container>
  );
};

export default TimelineCard;
